import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid , Header , Image , Icon } from 'semantic-ui-react';
import ThemeColorSetting from '../../constants/themeColor';
import coverBanner from '../../assets/home/coverBanner.png';
import deviceBanner from '../../assets/home/deviceBanner.png';

const styles = {
  coverContainer : {
    backgroundImage: 'linear-gradient(rgba(255,255,255,0.4),rgba(255,255,255,0.4)),url(' + coverBanner + ')',
    backgroundSize: 'cover',
    height : '80vh'
  },
  headerWrapper : {
    display : 'flex' ,
    flexDirection : 'column',
    alignItems : 'center' ,
    justifyContent : 'center'
  },
  imageWrapper : {
    display : 'flex' ,
    alignItems : 'center' ,
    justifyContent : 'center',
    padding : '5vh'
  },
  header : {
    color : 'white',
    fontSize : '60px',
    textShadow: '2px 2px'+ThemeColorSetting.black
  },
  subheader : {
    color : 'white',
    fontSize : '50px',
    textShadow: '2px 2px'+ThemeColorSetting.black
  },
  phoneEnquiry : {
    color : 'white',
    textShadow: '2px 2px'+ThemeColorSetting.black
  }
};

class CoverPitch extends Component {
  render() {
    const { string } = this.props;
    return(
      <Grid.Row columns='2' style={styles.coverContainer}>
        <Grid.Column style={styles.headerWrapper}>
          <Header as='h1' style={styles.header}>
            {string['coverPitchHeader']}
            <Header.Subheader style={styles.subheader}>{string['coverPitchSubHeader']}</Header.Subheader>
          </Header>
          <Header as='h2' style={styles.phoneEnquiry}><Icon name='phone' />{`${string['enquiryPhone']} : ${string['phone']}`}</Header>
        </Grid.Column>
        <Grid.Column style={styles.imageWrapper}>
          <Image src={deviceBanner} fluid/>
        </Grid.Column>
      </Grid.Row>
    )
  }
}

function mapStateToProps(state) {
  return {
    string : state.preference.string
  }
}

export default connect(mapStateToProps,null)(CoverPitch)



/** WEBPACK FOOTER **
 ** ./src/containers/pitch/coverPitch.js
 **/